export function dataInRequest(params = {}) {
  return {
    type: '@raizenerrologintegracaotransferencia/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@raizenerrologintegracaotransferencia/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@raizenerrologintegracaotransferencia/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@raizenerrologintegracaotransferencia/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@raizenerrologintegracaotransferencia/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@raizenerrologintegracaotransferencia/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@raizenerrologintegracaotransferencia/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@raizenerrologintegracaotransferencia/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@raizenerrologintegracaotransferencia/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@raizenerrologintegracaotransferencia/RECORD_FILTERING',
    payload: { params },
  };
}
